export default __webpack_public_path__ + "static/media/sns_logo-horizontal.a9142555.svg";